import { render, staticRenderFns } from "./DialogBlockCustomer.vue?vue&type=template&id=6330228c&scoped=true"
import script from "./DialogBlockCustomer.vue?vue&type=script&lang=js"
export * from "./DialogBlockCustomer.vue?vue&type=script&lang=js"
import style0 from "./DialogBlockCustomer.vue?vue&type=style&index=0&id=6330228c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330228c",
  null
  
)

export default component.exports